export const EXSBVATRATE_DELETE_RESET = 'EXSBVATRATE_DELETE_RESET'
export const EXSBVATRATE_DELETE_SET_ERROR = 'EXSBVATRATE_DELETE_SET_ERROR'
export const EXSBVATRATE_DELETE_SET_DELETED = 'EXSBVATRATE_DELETE_SET_DELETED'
export const EXSBVATRATE_DELETE_TOGGLE_LOADING = 'EXSBVATRATE_DELETE_TOGGLE_LOADING'
